import React, { useState } from "react";
import "./Showcase.scss";
import { H3, L, SLable, SLableIcon } from "../../ui/Typography";
import {
  Button,
  OTPinput,
  SearchBar,
  TextArea,
  Textbox,
  TypeHead,
} from "../../ui";
import { CalenderIcon, Info } from "../../ui/icons";

function ShowcaseTextbox() {
  /* otp logic code start */
  const [otpSm, setOtpSm] = useState("");
  const [statusSm, setStatusSm] = useState("");
  const [messageSm, setMessageSm] = useState("");

  const handleVerifySm = () => {
    if (otpSm === "8888") {
      setStatusSm("verified");
      setMessageSm("Verified");
    } else if (otpSm === "") {
      setStatusSm("error");
      setMessageSm("please add otp");
    } else {
      setStatusSm("error");
      setMessageSm("Incorrect OTP");
    }
  };
  /* otp logic code end */
  /* search result logic start */
  const sampleData = [
    { id: 1, label: "Elon Dusk" },
    { id: 2, label: "Mark Fckerberg" },
    { id: 3, label: "Bill Wiaites" },
    { id: 4, label: "Aam Saltman" },
    { id: 5, label: "Undar Pichai" },
    { id: 6, label: "Gautam Armani" },
    { id: 7, label: "Narendra Gandihi" },
    { id: 8, label: "Bitcoin" },
    { id: 9, label: "Binary" },
    { id: 10, label: "Biscuits" },
    { id: 11, label: "Bishop" },
    { id: 12, label: "Bisexual" },
    { id: 13, label: "Bi product" },
    { id: 14, label: "Bitter" },
    { id: 15, label: "Big Water melons" },
  ];
  /* search result logic end */

  return (
    <>
      <div className="showcase-wrapper">
        <H3>(TXTIN 1.1) Outline Textbox , 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L)h44px w322px</th>
                <th>(XL)h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="sm"
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="sm"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="sm"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="sm"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="sm"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(TXTIN 1.2) Outline Textbox with icon right, 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L)h44px w322px</th>
                <th>(XL)h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="sm"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                  {/* <TextboxIconRight
                    type="text"
                    placeholder="Enter Date"
                    size="sm"
                    widthSize="sm"
                    icon={CalenderIcon}
                  /> */}
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="md"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="lg"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="xl"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="sm"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="md"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="lg"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="xl"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(TXTIN 1.3) Outline Textbox with icon left, 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L)h44px w322px</th>
                <th>(XL)h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="sm"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                  {/* <TextboxIconLeft
                    type="text"
                    placeholder="Enter Date"
                    size="sm"
                    widthSize="sm"
                    icon={CalenderIcon}
                  /> */}
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="md"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="lg"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="xl"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="sm"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="md"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="lg"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Enter Date"
                    size="xl"
                    widthSize="sm"
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(TXTIN 1.4) Multiline Textbox</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h102px w166px</th>
                <th>(M) h132px w240px</th>
                <th>(L)h166px w322px</th>
                <th>(XL)h203px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TextArea placeholder="Enter Text" size="sm" widthSize="sm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et g elit, sed do
                    eiusmod tempor se
                  </TextArea>
                </td>
                <td>
                  <TextArea placeholder="Enter Text" size="md" widthSize="sm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et g elit, sed do
                    eiusmod tempor se
                  </TextArea>
                </td>
                <td>
                  <TextArea placeholder="Enter Text" size="lg" widthSize="sm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et g elit, sed do
                    eiusmod tempor se
                  </TextArea>
                </td>
                <td>
                  <TextArea placeholder="Enter Text" size="xl" widthSize="sm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et g elit, sed do
                    eiusmod tempor se
                  </TextArea>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TextArea
                    placeholder="Enter Text"
                    size="sm"
                    widthSize="sm"
                    disabled
                  ></TextArea>
                </td>
                <td>
                  <TextArea
                    placeholder="Enter Text"
                    size="md"
                    widthSize="sm"
                    disabled
                  ></TextArea>
                </td>
                <td>
                  <TextArea
                    placeholder="Enter Text"
                    size="lg"
                    widthSize="sm"
                    disabled
                  ></TextArea>
                </td>
                <td>
                  <TextArea
                    placeholder="Enter Text"
                    size="xl"
                    widthSize="sm"
                    disabled
                  ></TextArea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="showcase-wrapper">
        <H3>(TXTIN 2.1) - Textbox with typehead</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L) h44px w322px</th>
                <th>(XL) h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    /* onChange={(e) => console.log("Selected:", e.target.value)} */
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="md"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="lg"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="xl"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="md"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="lg"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="xl"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(TXTIN 2.2) - Textbox with typeahead & heading icon</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L) h44px w322px</th>
                <th>(XL) h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                    /* onChange={(e) => console.log("Selected:", e.target.value)} */
                  />
                  {/* <TypeHeadIconLeft
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                  /> */}
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="md"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="lg"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="xl"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="md"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="lg"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="xl"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="left"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(TXTIN 2.3) - Textbox with typeahead & tailing icon</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L) h44px w322px</th>
                <th>(XL) h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="md"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="lg"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="xl"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="sm"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="md"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="lg"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
                <td>
                  <TypeHead
                    placeholder="Enter text"
                    size="xl"
                    widthSize="sm"
                    suggestions={[
                      "Bitcoin",
                      "Binary",
                      "Biscuits",
                      "Bishop",
                      "Bisexual",
                      "Bi product",
                      "Bitter",
                      "Big Water melons",
                    ]}
                    icon={CalenderIcon}
                    iconSide="right"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="showcase-wrapper">
        <H3>EN TXTIN 3.1 - Encrypted input</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L)h44px w322px</th>
                <th>(XL)h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="sm"
                    widthSize="sm"
                    /* onChange={(e) => console.log("Selected:", e.target.value)} */
                  />
                </td>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="md"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="lg"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="xl"
                    widthSize="sm"
                  />
                </td>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="sm"
                    widthSize="sm"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="md"
                    widthSize="sm"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="lg"
                    widthSize="sm"
                    disabled
                  />
                </td>
                <td>
                  <Textbox
                    type="password"
                    placeholder="New password"
                    size="xl"
                    widthSize="sm"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>OTP TXTIN 3.2 - OTP input</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px</th>
                <th>(M) h36px</th>
                <th>(L) h44px</th>
                <th>(XL) h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <OTPinput
                    value={otpSm}
                    onChange={setOtpSm}
                    status={statusSm}
                    statusMessage={messageSm}
                    size="sm"
                  />
                  <Button size="sm" variant="primary" onClick={handleVerifySm}>
                    Verify
                  </Button>
                </td>
                <td>
                  <OTPinput
                    value={otpSm}
                    onChange={setOtpSm}
                    status={statusSm}
                    statusMessage={messageSm}
                    size="md"
                  />
                  <Button size="md" variant="primary" onClick={handleVerifySm}>
                    Verify
                  </Button>
                </td>
                <td>
                  <OTPinput
                    value={otpSm}
                    onChange={setOtpSm}
                    status={statusSm}
                    statusMessage={messageSm}
                    size="lg"
                  />
                  <Button size="lg" variant="primary" onClick={handleVerifySm}>
                    Verify
                  </Button>
                </td>
                <td>
                  <OTPinput
                    value={otpSm}
                    onChange={setOtpSm}
                    status={statusSm}
                    statusMessage={messageSm}
                    size="xl"
                  />
                  <Button size="xl" variant="primary" onClick={handleVerifySm}>
                    Verify
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <OTPinput size="sm" disabled />
                </td>
                <td>
                  <OTPinput size="md" disabled />
                </td>
                <td>
                  <OTPinput size="lg" disabled />
                </td>
                <td>
                  <OTPinput size="xl" disabled />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>Search bar</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M) h36px w240px</th>
                <th>(L) h44px w322px</th>
                <th>(XL) h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <SearchBar
                    data={sampleData}
                    onSelect={(item) => console.log("Selected:", item)}
                    size="sm"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <SearchBar
                    data={sampleData}
                    onSelect={(item) => console.log("Selected:", item)}
                    size="md"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <SearchBar
                    data={sampleData}
                    onSelect={(item) => console.log("Selected:", item)}
                    size="lg"
                    widthSize="sm"
                  />
                </td>
                <td>
                  <SearchBar
                    data={sampleData}
                    onSelect={(item) => console.log("Selected:", item)}
                    size="xl"
                    widthSize="sm"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="showcase-wrapper">
        <H3>(S) h28px , Gutter 16px</H3>
        <div className="showcase-inner">
          <table className="showcase-table align-left">
            <tbody>
              <tr>
                <th>166px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="sm"
                  />
                </td>
              </tr>
              <tr>
                <th>348px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="md"
                  />
                </td>
              </tr>
              <tr>
                <th>530px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="lg"
                  />
                </td>
              </tr>
              <tr>
                <th>712px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="xl"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(M) h36px , Gutter 24px</H3>
        <div className="showcase-inner">
          <table className="showcase-table align-left">
            <tbody>
              <tr>
                <th>240px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="sm"
                  />
                </td>
              </tr>
              <tr>
                <th>503px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="md"
                  />
                </td>
              </tr>
              <tr>
                <th>768px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="lg"
                  />
                </td>
              </tr>
              <tr>
                <th>1032px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="xl"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(L) h44px , Gutter 32px</H3>
        <div className="showcase-inner">
          <table className="showcase-table align-left">
            <tbody>
              <tr>
                <th>332px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="sm"
                  />
                </td>
              </tr>
              <tr>
                <th>768px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="md"
                  />
                </td>
              </tr>
              <tr>
                <th>1060px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="lg"
                  />
                </td>
              </tr>
              <tr>
                <th>1424px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="xl"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(XL) h54px , Gutter 36px</H3>
        <div className="showcase-inner">
          <table className="showcase-table align-left">
            <tbody>
              <tr>
                <th>412px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="sm"
                  />
                </td>
              </tr>
              <tr>
                <th>860px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="md"
                  />
                </td>
              </tr>
              <tr>
                <th>1060px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="lg"
                  />
                </td>
              </tr>
              <tr>
                <th>1424px</th>
                <td>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="xl"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseTextbox;
